// extracted by mini-css-extract-plugin
module.exports = {"root":"classes_root__3RgOD","content":"classes_content__3DBqk"};